import { Message, ThreadSummary, Notification } from '../types/user';
import apiClient from './client';

export const sendMessage = async (
  receiverUserId: string,
  content: string,
  jobId: number,
): Promise<Message> => {
  const response = await apiClient.post('/Message', { receiverUserId, content, jobId });
  return response.data.sentMessage as Message;
};

export const getMessages = async (
  jobId: number,
  contractorProfileId: number,
): Promise<Message[]> => {
  const response = await apiClient.get<Message[]>(`/Message/thread/${jobId}/${contractorProfileId}`);
  return response.data;
};

export const markMessageAsRead = async (messageId: number) => {
  const response = await apiClient.put(`/Message/mark-as-read/${messageId}`, {});
  return response.data;
};

export const getConversations = async (): Promise<ThreadSummary[]> => {
  const response = await apiClient.get<ThreadSummary[]>('/Message/conversations');
  return response.data;
};

export const getNotifications = async (): Promise<Notification[]> => {
  const response = await apiClient.get<Notification[]>('/Notification');
  return response.data;
};

export const requestReview = async (jobId: number) => {
  const response = await apiClient.post('/Notification/request-review', { jobId });
  return response.data;
};

export const markNotificationRead = async (notificationId: number) => {
  const response = await apiClient.put(`/Notification/${notificationId}/read`, {});
  return response.data;
};

export const uploadJobImage = async (
  jobId: number,
  type: 'BeforeWork' | 'AfterWork' | 'ClientCompletion',
  file: File,
) => {
  const formData = new FormData();
  formData.append('jobId', jobId.toString());
  formData.append('type', type);
  formData.append('file', file);
  const response = await apiClient.post('/JobImage', formData);
  return response.data;
};
